import asynCaseCall from '../../Action/CreateCase/createCase';
import pushGTMEvent from '../../util/helper/pushGTMEvent';
import { isEmpty } from '../../util/util';

const twoColStyling = (leftCol, rightCol) =>
  `<span style="color: #666666; line-height: 1.2"><span style="display: inline-block; width: 200px; vertical-align: top; font-weight: bold">${leftCol}</span><span style="display: inline-block; width: calc(100% - 200px); vertical-align: top; word-wrap: break-word">${rightCol}</span></span>`;

const configContents = ({
  state: {
    widgetName,
    langStrings,
    user,
    currentHULADetails,
    caseError,
  },
  dispatch,
}) => {
  const widgetFullName = {
    gac: 'Get activation code',
    hula: 'Request a home use license',
    pv: 'Request a previous version',
    cm: 'Change contract manager',
    sc: 'Change software coordinator',
    ccna: 'Change Company Name or Address',
  }[widgetName];

  const caseDisplay = [
    {
      isTitle: true,
      description: langStrings
        ? langStrings[widgetName].welcome.modalTitle
        : widgetFullName,
      id: 'adsk-page-title',
      paragraphStyle: { marginBottom: '-20px' },
    },
    {
      BGColor: '#f7f7f7',
      description: langStrings
        ? langStrings.contactOptions.caseDetails
        : 'Case details',
      style: { fontSize: '16px', fontWeight: 'bold' },
    },
    {
      BGColor: '#f7f7f7',
      BGPadding: '0px 20px 8px',
      description: twoColStyling(
        langStrings ? langStrings.contactInfoScreen.nameLabel : 'Name',
        `${user.firstName} ${user.lastName}`,
      ),
    },
    {
      BGColor: '#f7f7f7',
      BGPadding: '0px 20px 8px',
      description: twoColStyling(
        langStrings ? langStrings.contactInfoScreen.emailTitle : 'Email',
        user.email,
      ),
    },
  ];

  if(currentHULADetails.serialNumber) {
    caseDisplay.push({
      BGColor: '#f7f7f7',
      BGPadding: '0px 20px 8px',
      description: twoColStyling(
        langStrings ? langStrings.processInfoScreen.serialNumberLabel : 'Serial number',
        currentHULADetails.serialNumber,
      ),
    });
  }

  if(currentHULADetails.selectedProduct) {
    caseDisplay.push({
      BGColor: '#f7f7f7',
      BGPadding: '0px 20px 8px',
      description: twoColStyling(
        langStrings ? langStrings.contactOptions.productLabel : 'Product',
        currentHULADetails.selectedProduct,
      ),
    });
  }
  if(currentHULADetails.selectedProductVersion) {
    caseDisplay.push({
      BGColor: '#f7f7f7',
      BGPadding: '0px 20px 8px',
      description: twoColStyling(
        langStrings ? langStrings.pv.processInfoScreen.versionRequestingLabel : 'Version you’re requesting',
        currentHULADetails.selectedProductVersion,
      ),
    });
  }

  if(!isEmpty(currentHULADetails.authEmail)) {
    caseDisplay.push({
      BGColor: '#f7f7f7',
      BGPadding: '0px 20px 8px',
      description: twoColStyling(
        langStrings ? langStrings.processInfoScreen.emailForSerialNumPlaceholder : 'Email associated',
        currentHULADetails.authEmail,
      ),
    });
  }

  if(caseError.errorDesc !== '') {
    const description = caseError.errorDesc.replace(/(<([^>]+)>)/gi, "");
    caseDisplay.push({
      BGColor: '#f7f7f7',
      BGPadding: '0px 20px 8px',
      description: twoColStyling(
        langStrings ? langStrings.contactOptions.errorLabel : 'Error',
        caseError.errorMessage !== '' ? caseError.errorMessage : description,
      ),
    });
  }

  caseDisplay.push({
    description: langStrings
      ? langStrings.contactOptions.addtlCommentsReqd
      : 'Description',
    style: { fontSize: '14px', fontWeight: 'bold' },
    paragraphStyle: {
      marginTop: '15px',
      marginRight: '0px',
      marginLeft: '0px',
      marginBottom: '8px',
    },
    endWithRedStar: true,
  });

  caseDisplay.push({
    isTextArea: true,
    showWordCount: true,
    placeholder: langStrings
      ? langStrings.contactOptions.addtlCommentsMsg
      : 'Tell us any details we should know.',
    handleChange: (e) => dispatch({ type: 'ENTER_CASE_DESCRIPTION', payload: e.target.value }),
    paragraphStyle: { height: '30px' , color: 'red'},
  });

  return caseDisplay;
};

const configFooter = ({
  state: {
    credentials,
    hasExtension,
    langStrings,
    user,
    currentHULADetails,
    caseDescription,
    caseError,
    errorType,
  },
  dispatch,
}) => {
  const shouldExpand = () => {
    const { errorDesc, errorMessage } = caseError;

    if(!isEmpty(errorDesc)) {
      if (!isEmpty(errorMessage) && errorMessage === langStrings.requestFailedScreen.pageTitle2) {
        return false;
      } 
      return true;
    }
    return false;
  }
  return {
    hasQuestion: false,
    hasExtension,
    nextButtonContent: langStrings ? langStrings.buttons.submitButton : 'SUBMIT',
    enableNextButton: caseDescription.length > 0,
    handleNext: async () => asynCaseCall(currentHULADetails, dispatch, user, caseDescription, errorType, caseError, credentials),
    handleBack: () => {
      dispatch({ type: 'GO_TO_PREV_PAGE' });
      // Make sure user can see the scroll effect when they click back button from CreateCase page
      dispatch({ type: 'TOGGLE_QUESTION_EXTENSION' });
      setTimeout(() => dispatch({ type: 'TOGGLE_QUESTION_EXTENSION' }), 0);
    },
    handleAgentAnalytics: () => pushGTMEvent('ChatWithAgent'),
    expandForHULA: shouldExpand(),
  }
};

export default {
  configContents,
  configFooter,
};
